import { Grid } from "@mui/material";

import MonthsTabs from "./components/MonthsTabs";
import PageHeader from "../../../../../Components/Bits/PageHeader";

const CampaignPlanning2 = () => {
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <PageHeader
            title="Campaign Planning"
            subheader="Create and manage your call center campaigns effectively."
            breadcrumbs={[
              { title: "Dashboard", href: "/" },

              {
                title: "Campaign Planning",
                href: "/CDA/CallCenter/CampaignPlanning2",
              },
            ]}
          />
        </Grid>
        <Grid item xs={12}>
          <MonthsTabs />
        </Grid>
      </Grid>
    </div>
  );
};

export default CampaignPlanning2;
